<template>
    <div>
        <transition name="fade">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
    data() {
        return {

        }
    },
    methods: {
        ...mapMutations(['setUserRules'])
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue